export default __webpack_public_path__ + "static/media/arrow-choose-mode.b4818cbd.svg";